module.exports = __webpack_public_path__ + "static/media/ic-jingshi.cc14fae2.svg";